'use client';

import { SimpleGrid } from '@chakra-ui/react';
import { NestedArea } from '@habity/types';
import { AreaCard } from '../cards/AreaCard';
import { NoResults } from './components/NoResults';
import { placeholderAreas } from '@habity/constants';
import { getAreaPath } from '@habity/services';
import { useGridFullRows } from '~/hooks/useGridFullRows';

type AreasGridProps = {
  areas?: NestedArea[] | null;
  areasLoading: boolean;
};

export const AreasGrid = ({
  areas: realAreas,
  areasLoading,
}: AreasGridProps) => {
  const areas =
    areasLoading && realAreas && realAreas.length === 0
      ? placeholderAreas
      : realAreas && realAreas.length > 0
      ? realAreas
      : [];

  const { gridRef, visibleItems: visibleAreas } = useGridFullRows(areas);
  const actualVisibleAreas =
    areas.length === 0 && !areasLoading ? [] : visibleAreas;

  if (!actualVisibleAreas?.length) {
    return <NoResults tab="areas" />;
  }

  return (
    <SimpleGrid
      ref={gridRef}
      columns={{ mobile: 1, tablet: 2, desktop: 3 }}
      rowGap="10"
      columnGap="5"
      pb={{ mobile: '12', desktop: '24' }}
      pt="0"
    >
      {actualVisibleAreas.map((area, index) => (
        <AreaCard
          key={index}
          href={getAreaPath(area)}
          area={area}
          isLoading={areasLoading && !('id' in area)}
        />
      ))}
    </SimpleGrid>
  );
};
